import { CHOOSE_SERVICES } from '@/constants/AppointmentSteps'

const getInitialState = () => ({
    loading: {
        general: false,
        publicServices: false,
        locations: false,
        employees: false,
        schedule: false,
        timeSlots: false,
        children: false,
        pets: false
    },
    issueId: undefined,
    mainProblem: undefined,
    serviceCategories: [],
    citiesByCategory: {},
    publicServices: [],
    citiesByService: {},
    locations: [],
    employees: [],
    employeeSchedule: undefined,
    bookedTimes: [],
    customerChildren: [],
    customerPets: [],
    currentIndex: 0,
    appointments: [getEmptyAppointment()],
    currentStep: CHOOSE_SERVICES
})

const getEmptyAppointment = () => (
    {
        // Step 1
        selectedCategory: undefined,
        serviceKeyword: '',
        selectedServiceState: undefined,
        selectedServiceCities: undefined,
        publicService: undefined,
        service: undefined,

        // Step 2
        locationKeyword: '',
        selectedLocationState: undefined,
        selectedLocationCities: undefined,
        availableDates: [],
        bookingDate: undefined,
        selectedTimeSlotIndex: undefined,
        selectedTime: undefined,
        location: undefined,
        employee: undefined,
        schedule: undefined,

        // Step 3
        customerType: undefined,
        customer: {
            id: undefined,
            name: undefined,
            childId: undefined,
            petId: undefined
        }
    }
)

export { getInitialState, getEmptyAppointment }
